import React, { FunctionComponent } from "react";
import Placeholder, { PlaceholderProps } from "./Placeholder";
import imageSrc from "./Search.png";

type SearchPlaceholderProps = Partial<PlaceholderProps>;

const SearchPlaceholder: FunctionComponent<SearchPlaceholderProps> = (props) => {
	// For the optional properties, we could just use ...xxx to include them
	const { titleProps, ...otherProps } = props;

	return (
		<Placeholder
			titleProps={titleProps || { res: "SEARCH_NO_RESULTS" }}
			{...otherProps}
		>
			{{
				image: <img height={72} src={imageSrc} />,
			}}
		</Placeholder>
	);
};

export default SearchPlaceholder;